<template>
  <div>
    <b-card no-body
      class="mb-1">
      <b-card-body class="p-1">
        <b-row>
          <div class="col-12 col-md-3">
            <b-form-group label="Từ ngày"
              class="mb-0"
              label-for="start_date">
              <flat-pickr v-model="start_date"
                :value="start_date"
                class="form-control"
                :config="config_date"
                placeholder="dd-mm-yyyy" />
            </b-form-group>
          </div>
          <div class="col-12 col-md-3">
            <b-form-group label="Đến ngày"
              class="mb-0"
              label-for="end_date">
              <flat-pickr v-model="end_date"
                :value="end_date"
                class="form-control"
                :config="config_date"
                placeholder="dd-mm-yyyy" />
            </b-form-group>
          </div>
          <b-col cols="12"
            md="3">
            <b-form-group label="Kênh liên kết"
              class="mb-0"
              label-for="source_id">
              <v-select v-model="source_id"
                class="w-100"
                :options="dataSource"
                :reduce="(val) => val.code"
                placeholder="--Chọn--"
                @input="(val) => $emit('update:source_id', val)" />
            </b-form-group>
          </b-col>
          <b-col cols="12"
            md="3">
            <label>Tìm kiếm</label>
            <b-input-group>
              <b-form-input v-model="localSearchQuery"
                class="d-inline-block"
                placeholder="Tiêu đề bài viết"
                @keyup.enter="updateSearchQuery" />
              <b-input-group-append>
                <b-button variant="primary"
                  @click="updateSearchQuery">
                  <feather-icon icon="SearchIcon" />
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <!-- List -->
    <b-overlay :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm">
      <b-card no-body
        class="mb-0">
        <b-table ref="refListTable"
          :items="dataItems"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching records found">
          <!-- Column: Status -->
          <template #cell(title)="data">
            <a @click="showDialog(data.item.id, data.item.lang)">
              <strong v-if="data.item.lang == 'en'">{{ data.item.title_en }}</strong>
              <strong v-else>{{ data.item.title }}</strong>
            </a>
          </template>
          <template #cell(actions)="data">
            <!-- <b-button size="sm"
              class=""
              variant="warning"
              @click="edit(data.item)">
              <span class="text-nowrap">
                <feather-icon icon="EditIcon" />
              </span>
            </b-button> -->
            <b-button size="sm"
              class="ms-2"
              variant="danger"
              v-if="$can('crawler.destroy', 'Crawler')"
              @click="onDestroy(data.item)">
              <span class="text-nowrap">
                <feather-icon icon="TrashIcon" />
              </span>
            </b-button>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start">
              <span class="text-muted">{{ $t('show_to_entries', { from: dataMeta.from, to: dataMeta.to, of: dataMeta.of, }) }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <b-pagination v-model="currentPage"
                :total-rows="total"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item">
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon"
                    size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon"
                    size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>
    <b-modal id="modalCrawlerDialog"
      size="lg"
      cancel-variant="secondary"
      no-close-on-backdrop
      :title="dialog_title"
      @ok="handleOk"
      ok-title="Tạo thành tin">
      <template #modal-footer>
        <div class="text-center">
          <b-button variant="gradient-secondary"
            class="btn-sm"
            @click="hideDialog">Đóng</b-button>
          <b-button variant="gradient-success"
            class="btn-sm ml-1 mr-1"
            @click="handleTranslate"><font-awesome-icon icon="fa-solid fa-language" /> Dịch</b-button>
          <b-button variant="gradient-primary"
            class="btn-sm"
            @click="handleOk"> Tạo thành tin </b-button>
        </div>
      </template>
      <crawler-dialog :crawler_id="crawler_id"
        :lang="lang" />
    </b-modal>
  </div>
</template>
<script>
import {
  BCard,
  BOverlay,
  BCardBody,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BFormCheckbox,
  BPagination,
  BInputGroupAppend,
  BInputGroup,
  BFormGroup,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';
import { useRouter, showToast } from '@core/utils/utils';
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue';
import CrawlerDialog from './CrawlerDialog.vue';
import flatPickr from 'vue-flatpickr-component';
import { Vietnamese } from 'flatpickr/dist/l10n/vn';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faLanguage } from '@fortawesome/free-solid-svg-icons';
library.add(faLanguage);
export default {
  components: {
    BOverlay,
    BCard,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BPagination,
    BInputGroupAppend,
    AppBreadcrumb,
    BInputGroup,
    BFormCheckbox,
    vSelect,
    CrawlerDialog,
    BFormGroup,
    flatPickr,
    FontAwesomeIcon,
  },
  data() {
    return {
      dialog_title: 'Xem tin',
      crawler_id: '',
      lang: '',
    };
  },
  setup() {
    const { router } = useRouter();
    const refListTable = ref(null);
    const tableColumns = [
      { key: 'id', sortable: false, label: 'ID', thAttr: { width: '6%' } },
      { key: 'title', sortable: false, label: 'Tiêu đề' },
      { key: 'body', sortable: false, label: 'Nội dung' },
      {
        key: 'source_name',
        sortable: false,
        label: 'Kênh liên kết',
        thAttr: { width: '10%' },
      },
      {
        key: 'config_name',
        sortable: false,
        label: 'Danh mục',
        //  thAttr: { width: '10%' },
      },
      {
        key: 'created_at',
        sortable: false,
        label: 'Ngày lấy',
        //   thAttr: { width: '10%' },
      },
      {
        key: 'user',
        sortable: false,
        label: 'Người tạo',
      },
      // {
      //   key: 'actions',
      //   label: 'Hành động',
      //   class: 'action',
      //   thAttr: { width: '6%' },
      // },
    ];

    const perPage = ref(30);
    const total = ref(0);
    const currentPage = ref(1);
    const perPageOptions = [10, 30, 50, 100];
    const searchQuery = ref('');
    const start_date = ref('');
    const end_date = ref('');
    const source_id = ref('');
    const localSearchQuery = ref('');
    const loading = ref(false);
    const dataItems = ref([]);

    const fetchAll = () => {
      loading.value = true;
      store
        .dispatch('crawler/fetchAll', {
          keyword: searchQuery.value,
          perPage: perPage.value,
          page: currentPage.value,
          start_date: start_date.value,
          end_date: end_date.value,
          source_id: source_id.value,
        })
        .then((response) => {
          loading.value = false;
          if (response.data.code === 200) {
            dataItems.value = response.data.data;
            total.value = response.data.total;
          }
        });
    };
    const dataMeta = computed(() => {
      const localItemsCount = refListTable.value
        ? refListTable.value.localItems.length
        : 0;
      return {
        from:
          perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
        to: perPage.value * (currentPage.value - 1) + localItemsCount,
        of: total.value,
      };
    });
    fetchAll();
    watch([currentPage, perPage, searchQuery, source_id], () => {
      refetchData();
    });

    const refetchData = () => {
      fetchAll();
    };
    const dataSource = [
      { label: 'CNN', code: 2 },
      { label: 'TTXVN', code: 1 },
    ];

    const updateSearchQuery = () => {
      //searchQuery.value = localSearchQuery.value;
      // let startDate,
      //   endDate = 0;
      // if (start_date.value) {
      //   startDate = Date.parse(start_date.value) / 1000;
      // }
      // if (end_date.value) {
      //   endDate = Date.parse(end_date.value) / 1000;
      // }
      // if (startDate && startDate > endDate) {
      //   showToast('Đến ngày phải lớn hơn từ ngày');
      // } else {
      //   fetchAll();
      // }

      searchQuery.value = localSearchQuery.value
      if (start_date.value && start_date.value > end_date.value) {
        showToast('Đến ngày phải lớn hơn từ ngày');
        return false
      }
      fetchAll();



    };
    const config_date = ref({
      dateFormat: 'd-m-Y',
      wrap: true,
      locale: Vietnamese, // locale for this instance only
    });
    return {
      loading,
      dataItems,
      perPage,
      tableColumns,
      perPage,
      currentPage,
      total,
      dataMeta,
      perPageOptions,
      refListTable,
      refetchData,
      updateSearchQuery,
      localSearchQuery,
      config_date,
      start_date,
      end_date,
      source_id,
      dataSource,
    };
  },
  methods: {
    hideDialog() {
      this.$bvModal.hide('modalCrawlerDialog');
    },
    handleTranslate() {
      this.lang = this.lang == 'en' ? 'vi' : 'en';
    },
    handleOk(bvModalEvent) {
      bvModalEvent.preventDefault();
      if (this.crawler_id) {
        let params = { id: this.crawler_id, lang: this.lang };
        store.dispatch('crawler/create', params).then((response) => {
          let result = response.data;
          if (result.code == 200) {
            this.crawler_id = null;
            this.lang = null;
            this.$bvModal.hide('modalCrawlerDialog');
            //let route = this.$router.push({ name: 'article-private' });
            window.open('/article/private');
            //this.$router.push({ name: 'article-edit', params: { id: data.id } });
          } else {
            showToast(result.message);
          }
        });
      }
    },
    onDestroy(item) {
      this.$swal({
        title: '',
        text: 'Bạn có chắc chắn muốn xóa bài viết này không?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.isConfirmed) {
          const { id } = item;
          store.dispatch('crawler/destroy', { id }).then((response) => {
            const result = response.data;
            if (result.code === 200) {
              this.refetchData();
              showToast(result.message, { variant: 'success' });
            } else {
              showToast(result.message);
            }
          });
        }
      });
    },
    showDialog(id, lang) {
      this.crawler_id = id;
      this.lang = lang;
      this.$bvModal.show('modalCrawlerDialog');
    },
    updateStatus(item) {
      const { id } = item;
      store
        .dispatch('category/status', { id })
        .then((response) => {
          const result = response.data;
          let msg_class = '';
          if (result.code === 200) {
            msg_class = 'success';
            this.refetchData();
          }
          showToast(result.message, { variant: msg_class });
        })
        .catch((error) => { });
    },
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
